import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import PageContainer from '../../components/layout/PageContainer/PageContainer';
import RegisterForm from '../../components/auth/RegisterForm/RegisterForm';
import { useAuth } from '../../hooks/useAuth';

const Register: React.FC = () => {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();
  
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/start-trial');
    }
  }, [isAuthenticated, navigate]);
  
  return (
    <PageContainer>
      <div className="max-w-md mx-auto mt-10">
        <RegisterForm />
      </div>
    </PageContainer>
  );
};

export default Register; 